import { safeParse } from "valibot"
import ls, { getJsonOrNullFromLocalStorage } from "../../../localStorage"
import { InputProfileSchema, type InputProfile } from "./InputProfile.type"
import { InputProfileMetaSchema, type InputProfileMeta } from "./InputProfileMeta.type"

export const INPUT_PROFILE_META_LS_KEY = 'input_profile'
export const INPUT_PROFILE_PREFIX = 'input_profile_'
export const MAX_INPUT_PROFILES = 3

export function getInputProfileMetaFromLocalStorage(): InputProfileMeta | null {
  const result = safeParse(InputProfileMetaSchema, getJsonOrNullFromLocalStorage(INPUT_PROFILE_META_LS_KEY))
  if (result.success) {
    return result.output
  }
  return null
}

export function setInputProfileMetaToLocalStorage(meta: InputProfileMeta): void {
  ls.setItem(INPUT_PROFILE_META_LS_KEY, JSON.stringify(meta))
}

export function getInputProfileFromLocalStorage(id: number): InputProfile | null {
  const key = `${INPUT_PROFILE_PREFIX}${id}`
  const result = safeParse(InputProfileSchema, getJsonOrNullFromLocalStorage(key))
  if (result.success) {
    return result.output
  }
  return null
}

export function setInputProfileToLocalStorage(profile: InputProfile): void {
  const key = `${INPUT_PROFILE_PREFIX}${profile.id}`
  ls.setItem(key, JSON.stringify(profile))
}

export function deleteInputProfileFromLocalStorage(id: number): void {
  const key = `${INPUT_PROFILE_PREFIX}${id}`
  ls.removeItem(key)
}

export function getAllInputProfileIdsFromLocalStorage(): number[] {
  const ids: number[] = []
  for (let i = 0; i < ls.length; i++) {
    const key = ls.key(i)
    if (key && key.startsWith(INPUT_PROFILE_PREFIX)) {
      const idStr = key.slice(INPUT_PROFILE_PREFIX.length)
      const id = parseInt(idStr, 10)
      if (!isNaN(id)) {
        ids.push(id)
      }
    }
  }
  return ids.sort((a, b) => a - b)
}

export function getAllInputProfilesFromLocalStorage(): InputProfile[] {
  const ids = getAllInputProfileIdsFromLocalStorage()
  const profiles: InputProfile[] = []
  for (const id of ids) {
    const profile = getInputProfileFromLocalStorage(id)
    if (profile) {
      profiles.push(profile)
    }
  }
  return profiles
}

